import React from 'react';
import { VerticalName } from '@/shared/types/category';
import { CatalogCompany, CatalogCompanyType } from '@/shared/types/catalog';
import { getCreatorHubSupplierProfilePagePath, getVerticalName } from '@/shared/utils/sourcing-marketplace-util';
import { logCommonView } from '@/lib/service';
import { EventSource } from '@/shared/constants/event';
import TextboxWithAttachment from './TextboxWithAttachment';
import { useCreateAccountProvider } from '@/lib/context';
import { CHAT_WITH_FACTORY_DESCRIPTION } from '@/shared/constants/sourcing-marketplace';
import './index.less';

interface IProps {
  supplier: CatalogCompany;
}

const RequestQuote = ({ supplier }: IProps) => {
  const { showSignupDialogFromSourcing } = useCreateAccountProvider();

  const isServices = supplier?.type === CatalogCompanyType.SPECIALIST;
  const supplierType = getVerticalName(
    isServices ? VerticalName.SERVICES : VerticalName.PRODUCTS,
    /* isSingular */ true,
  );
  const generalInputPlaceholderText = isServices
    ? 'Explain your project needs'
    : 'e.g. What is the best price you can offer?';

  const submit = async () => {
    logCommonView(EventSource.SUPPLIER_PROFILE, 'contact-button-clicked');
    showSignupDialogFromSourcing(
      CHAT_WITH_FACTORY_DESCRIPTION,
      getCreatorHubSupplierProfilePagePath(supplier.id),
      'factory_details_page',
    );
  };

  return (
    <div className="general-request-form">
      <h2 className="title">Submit your custom request</h2>
      <TextboxWithAttachment
        inputPlaceholderText={generalInputPlaceholderText}
        requireProjectBrief={supplier.isPremiumSupplier}
        buttonConfig={{
          buttonText: 'Contact',
          onClick: submit,
        }}
      />
    </div>
  );
};

export default RequestQuote;
